
(function () {
  function initSherpaHeader(root) {
    if (!root || root.dataset.shReady === 'true') return;
    root.dataset.shReady = 'true';

    var toggle = root.querySelector('.sh-header__mobile-toggle');
    var mobile = root.querySelector('.sh-header__mobile');

    if (toggle && mobile) {
      var closeButtons = mobile.querySelectorAll('[data-sh-mobile-close]');

      function openMobile() {
        mobile.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sh-mobile-menu-open');
        document.body.classList.add('sh-mobile-menu-open');
      }

      function closeMobile() {
        mobile.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sh-mobile-menu-open');
        document.body.classList.remove('sh-mobile-menu-open');
      }

      toggle.addEventListener('click', function () {
        if (mobile.hidden) openMobile();
        else closeMobile();
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeMobile);
      });

      mobile.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMobile);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !mobile.hidden) closeMobile();
      });
    }

    root.querySelectorAll('.sh-header__dropdown-wrap').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        root.querySelectorAll('.sh-header__dropdown-wrap[open]').forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('.sh-header').forEach(initSherpaHeader);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
